// Constants
import { HEADER_CLASS_NAME, SHOW_AS_COLUMN } from "@/Constants/tables";

const HEADER_CUSTOM_CLASS_NAME = `table-header ${HEADER_CLASS_NAME} ${SHOW_AS_COLUMN} fs-12`;
const ROW_HEIGHT = 25;
const DRAW_ID_MAP = {
	DRAW_TEXT: "draw_text",
	CHILD: "child",
	LAST_DRAW: "last_row_draw",
};
const DOLLAR_SYMBOL_CLASSNAME = "cell-with-dollar-symbol before:text-[12px] before:font-normal before:text-default before:font-sans";
const DEFAULT_HEIGHT = 25;

export { ROW_HEIGHT, DRAW_ID_MAP, HEADER_CUSTOM_CLASS_NAME, DOLLAR_SYMBOL_CLASSNAME, DEFAULT_HEIGHT };
